import React from "react";
import { useSelector } from "react-redux";
import { getAppColor } from "@icarius-app/selectors";
import { CheckBoxIcon } from "@icarius-icons";
import { IMAGES_ENDPOINT } from "@icarius-connection/endpoints";

const ImageGrid = (props) => {
    const { images, selectedImage, handleSelect } = props;

    const color = useSelector(getAppColor);

    return (
        <div
            style={{
                display: "flex",
                flexWrap: "wrap",
                alignItems: "center",
                justifyContent: "center",
            }}
        >
            {images.map(({ img }, index) => {
                const isSelected = img === selectedImage;

                return (
                    <div
                        key={index}
                        style={{
                            width: 230,
                            height: 150,
                            position: "relative",
                            cursor: "pointer",
                            border: isSelected ? `solid 2px ${color}` : "",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                        }}
                    >
                        {isSelected ? (
                            <CheckBoxIcon style={{ fill: color, position: "absolute", bottom: 20, right: 20 }} />
                        ) : null}
                        <img
                            style={{ margin: 5, maxWidth: 220, maxHeight: 140 }}
                            onClick={() => handleSelect(img)}
                            src={IMAGES_ENDPOINT + img}
                            alt={"imageNotFound"}
                        />
                    </div>
                );
            })}
        </div>
    );
};

export default ImageGrid;
